export const MONTH_LABELS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];

// Four-digit years, the span antd's year panel formats.
export const YEAR_MIN = 1000;
export const YEAR_MAX = 9999;

// Must match `$year-row` in PeriodPicker.module.scss.
export const YEAR_ROW_REM = 2;
export const YEAR_VISIBLE_ROWS = 5;
export const YEAR_OVERSCAN = 3;
